<template>
    <div>
        <meClientes v-if="isCliente"/>
        <meFuncionarios v-else/>
    </div>
</template>
<script>
import { VueEasyJwt } from 'vue-easy-jwt'
import meClientes from "@/components/configs/meClientes"
import meFuncionarios from "@/components/configs/meFuncionarios"

export default {
    name: 'me',
    components: { meFuncionarios, meClientes },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            level: '',
            isCliente: false
        }
    },
    methods: {
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.level==='cliente') {
            this.isCliente = true
        } else {
            this.isCliente = false
        }
    }
}
</script>
<style>
</style>